var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.room
    ? _c(
        "div",
        [
          _c("div", { staticClass: "va-subtitle flex align-center" }, [
            _vm._v(" " + _vm._s(_vm.$t("roomCommands.title")) + " ")
          ]),
          _c(
            "va-card",
            { staticClass: "fit-height mb-6" },
            [
              _c("div", { staticClass: "va-subtitle-s" }, [
                _vm._v(_vm._s(_vm.$t("common.roomName")))
              ]),
              _c("va-text-field", {
                attrs: {
                  label: _vm.$t("common.roomName"),
                  value: _vm.room.name,
                  dense: "",
                  disabled: ""
                }
              })
            ],
            1
          ),
          _c("remote-providers", { attrs: { room: _vm.room } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }